<template>
  <span class="inline-block group flex items-center justify-start">
    <div
      :class="classObject"
      class="rounded-full shadow p-1 border border-neutral-300 flex items-center justify-center bg-ocean-800 text-white rounded-full flex items-center justify-center text-xl"
    >
      {{ getInitials }}
    </div>
    <span
      v-if="showName"
      class="text-neutral-600 group-hover:text-neutral-900"
    >
      {{ name }}
    </span>
  </span>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserMd } from '@fortawesome/pro-light-svg-icons';

library.add(faUserMd);

export default {
  name: 'VetsterClientImage',

  props: {
    name: {
      default: undefined,
      type: String,
    },
    size: {
      default: 'sm',
      type: String,
    },
    noMargin: {
      default: false,
      type: Boolean,
    },
    showName: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    getInitials() {
      return this.name.charAt(0).toUpperCase();
    },
    classFont() {
      return {
        'text-2xl': this.size === 'sm',
        'text-3xl': this.size === 'md' || this.size === 'lg',
        'text-4xl': this.size === '2xl',
      };
    },
    classObject() {
      return {
        'h-10 w-10': this.size === 'sm',
        'h-16 w-16': this.size === 'md',
        'h-20 w-20': this.size === 'lg',
        'h-24 w-24 md:h-32 md:w-32': this.size === '2xl',
        'mr-3': !this.noMargin,
      };
    },
  },
};
</script>
